import { http } from 'services/http';
import type { CargoRes, UpdateCargoReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { CARGO_GET_ONE } from '../query-keys.ts';

export const useUpdateCargo = (cargoId: number) => {
  return useMutationBase<CargoRes, unknown, UpdateCargoReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<CargoRes>(`/v1/cargo/${cargoId}`, variables);

      return res.data;
    },

    invalidateCallback: () => [[CARGO_GET_ONE, cargoId]],
  });
};
